var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChoosenStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9193 2.86801C11.0293 2.67917 11.1869 2.52248 11.3764 2.41358C11.5659 2.30468 11.7807 2.24738 11.9993 2.24738C12.2178 2.24738 12.4326 2.30468 12.6221 2.41358C12.8116 2.52248 12.9692 2.67917 13.0793 2.86801L15.8743 7.66601L21.3023 8.84201C21.5158 8.88841 21.7134 8.98996 21.8754 9.13654C22.0374 9.28313 22.1582 9.46962 22.2257 9.67743C22.2932 9.88525 22.305 10.1071 22.26 10.3209C22.215 10.5347 22.1148 10.733 21.9693 10.896L18.2693 15.037L18.8293 20.562C18.8513 20.7796 18.816 20.9991 18.7267 21.1987C18.6374 21.3983 18.4973 21.571 18.3204 21.6996C18.1435 21.8281 17.9359 21.908 17.7185 21.9312C17.5011 21.9545 17.2813 21.9203 17.0813 21.832L11.9993 19.592L6.91725 21.832C6.71717 21.9203 6.49744 21.9545 6.28001 21.9312C6.06257 21.908 5.85504 21.8281 5.67812 21.6996C5.50121 21.571 5.36112 21.3983 5.27182 21.1987C5.18253 20.9991 5.14716 20.7796 5.16925 20.562L5.72925 15.037L2.02925 10.897C1.88348 10.734 1.78301 10.5357 1.73787 10.3217C1.69272 10.1078 1.70449 9.88574 1.772 9.67777C1.8395 9.46979 1.96038 9.28316 2.12256 9.13651C2.28474 8.98986 2.48256 8.88831 2.69625 8.84201L8.12425 7.66601L10.9193 2.86801Z",
    fill: "#E48F0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoosenStar);
export default __webpack_public_path__ + "static/media/choosenStar.df493d1309358132ad44340b051d87aa.svg";
export { ForwardRef as ReactComponent };